module.exports = __webpack_public_path__ + "img/labmem_text_share_sc.34f74f24.png";